import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgAzelaicAcidGlyphSecondary from './svgs/AzelaicAcidGlyphSecondary.js';
import SvgAzelaicAcidGlyph from './svgs/AzelaicAcidGlyph.js';
import { useIcon } from '../../shared-components/icon/index.js';

var azelaicAcidGlyph = (props => useIcon(SvgAzelaicAcidGlyph, SvgAzelaicAcidGlyphSecondary, props));

export { azelaicAcidGlyph as default };
